import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge, validators } from 'tailwind-merge/es5';

const isKebabNumber = (classPart: string) => /^(\d+-)*\d+$/.test(classPart);

const twMerge = extendTailwindMerge({
  override: {
    classGroups: {
      'font-size': [
        {
          text: [
            validators.isNumber,
            validators.isArbitraryLength,
            isKebabNumber,
            (classPart: string) => /size-inherit/.test(classPart),
          ],
        },
      ],
    },
    conflictingClassGroups: {
      // In our tailwind.config we override the default font-size scale without line-height
      // I.e. font-size should no longer conflict with line-height
      // https://tailwindcss.com/docs/font-size
      'font-size': [],
    },
  },
  extend: {
    classGroups: {
      'text-alignment': [{ text: ['initial'] }],
      z: [{ z: ['drawer', 'modal', 'notification', 'sticky'] }],
      rounded: [{ rounded: ['default'] }],
      leading: [{ leading: ['inherit'] }],
      animate: [
        {
          animate: [
            'fade-in',
            'fade-out',
            'float',
            'fade-in-bottom',
            'fade-in-top',
            'fade-in-left',
            'fade-in-right',
            'fade-out-right',
            'fade-out-left',
            'fade-out-bottom',
            'fade-out-top',
          ],
        },
      ],
    },
  },
});

export function cn(...classes: ClassValue[]) {
  return twMerge(clsx(classes));
}
